import React from "react";

import { Container } from "./formWrapper.styled";

type FormWrapperProps = {
  children: JSX.Element[];
};
const FormWrapper = ({ children }: FormWrapperProps) => {
  return <Container>{children}</Container>;
};

export default FormWrapper;
